import React from 'react';
import { RolesUser } from 'shared/enums';
import { TItemsTab } from 'shared/types/types';
import { Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import { configTabs } from 'shared/helpers/utils';
import { Button, Tabs } from 'antd';
import { newsCreateActions } from 'entities/news/model/createNews';
import { useTabsNavigate } from 'shared/hooks';
import NewsPublicated from './newsPublicated/NewsPublicated';
import NewsArchive from './newsArchive/NewsArchive';
import NewsUnublicated from './newsUnpublicated/NewsUnpublicated';
import style from './index.module.scss';

const allRoles = [
  RolesUser.HRDirector,
  RolesUser.Consultant,
  RolesUser.Employee,
  RolesUser.FirstLine,
  RolesUser.SecondLine,
];

const itemsTab: TItemsTab = [
  {
    label: 'Опубликованное',
    key: 'publicated',
    children: <NewsPublicated />,
    role: allRoles,
  },
  {
    label: 'Неопубликованное',
    key: 'unpublicated',
    children: <NewsUnublicated />,
    role: allRoles,
  },
  {
    label: 'Архив',
    key: 'archive',
    children: <NewsArchive />,
    role: allRoles,
  },
];
const News = () => {
  const dispatch = useAppDispatch();
  const [activeTab, handler] = useTabsNavigate('poll', itemsTab[0].key);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const tabPane = configTabs(role, itemsTab);

  const setInitialTab = (tab: string) => {
    const exist = itemsTab.every(elem => elem.key !== tab);
    if (!exist) {
      return tab;
    }
    return 'publicated';
  };

  return (
    <>
      <div className={style.actions}>
        <h3>Новости</h3>
        <Link to={'/news/create'}>
          <Button
            type="primary"
            onClick={() => {
              dispatch(newsCreateActions.clearNews());
            }}
          >
            + Добавить новость
          </Button>
        </Link>
      </div>

      <div className={style.wrap}>
        {role && (
          <Tabs activeKey={setInitialTab(activeTab)} onChange={handler} destroyInactiveTabPane items={tabPane}></Tabs>
        )}
      </div>
    </>
  );
};

export default News;
